import styled from "styled-components";
import { useAllContexts } from "../../../hooks/useAllContexts";

const MobilityButton = () => {
  const { variables, mobility } = useAllContexts();
  const { showMobility, setShowMobility } = variables;
  const { mobilityLoading } = mobility;

  return (
    <MobilityBtn
      $isSelected={showMobility}
      $isMobilityLoading={mobilityLoading}
      onClick={() => !mobilityLoading && setShowMobility(!showMobility)}
    >
      {mobilityLoading
        ? "Φόρτωση κυκλοφορίας"
        : showMobility
        ? "Απόκρυψη κυκλοφορίας"
        : "Εμφάνιση κυκλοφορίας"}
    </MobilityBtn>
  );
};

export default MobilityButton;

const MobilityBtn = styled.div`
  position: absolute;
  bottom: 0;
  left: calc((100vw + 50px) / 2);
  width: 240px;
  height: 26px;
  background-color: ${({ $isSelected, $isMobilityLoading }) =>
    $isMobilityLoading ? "gray" : $isSelected ? "green" : "#ff0000"};
  color: ${({ $isMobilityLoading }) =>
    $isMobilityLoading ? "darkgray" : "#ffffff"};
  cursor: ${({ $isMobilityLoading }) =>
    $isMobilityLoading ? "not-allowed" : "pointer"};
  transition: all 0.3s ease-in-out;
  z-index: 400;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px 20px 0 0;

  &:hover {
    background-color: ${({ $isMobilityLoading }) =>
      $isMobilityLoading ? "gray" : "#ffb09c"};
    transition: all 0.3s ease-in-out;
    color: ${({ $isMobilityLoading }) =>
      $isMobilityLoading ? "darkgray" : "#333"};
  }
`;
